import * as Sentry from '@sentry/browser'

if (process.env['REACT_APP_SENTRY_DSN']) {
  Sentry.init({
    dsn: process.env['REACT_APP_SENTRY_DSN'],
    release: process.env['REACT_APP_RELEASE_VER'],
    environment: process.env['REACT_APP_TARGET'],
  })
}

export default Sentry
